<template>
  <div class="detail">
    <div class="title">
      {{ activity.title }}
    </div>
    <span class="split"></span>
    <div v-html="activity.content" class="content">
      <!-- {{ activity.content }} -->
    </div>
  </div>
</template>

<script>
import { activity } from '@/api'

export default {
  name: 'ActivityDetail',
  data () {
    return {
      activityId: this.$route.params.id,
      activity: {}
    }
  },
  // props: [ 'activityId' ],
  methods: {
    getActivity (activityId) {
      // console.log(activityId)
      activity(activityId).then(response => {
        if (response && response.data && response.data.success === true) {
          // console.log(response.data.data)
          this.activity = response.data.data
        } else if (response && response.data && response.data.success === false) {
        }
      })
    }
  },
  created () {
    this.getActivity(this.activityId)
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    '$route' (to, from) {
      // console.log(from)
      // console.log(to)
      // console.log(this.getStatus(this.$route.path))
      this.getActivity(to.params.id)
    }
  }
}
</script>

<style lang="less">
.detail {
  color: #999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    line-height: 140px;
    font-size: 24px;
  }
  .split {
    display: block;
    width: 80%;
    height: 1px;
    background: #262626;
  }
  .content {
    padding-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
    table {
      margin: auto !important;
      width: 80% !important;
      border: solid #333333 !important;
      border-width: 1px 0px 0px 1px !important;
      td, th {
        border:solid #333333 !important;
        border-width: 0px 1px 1px 0px !important;
        padding: 5px 0px !important;
      }
      // th {
      //   border:solid #333333 !important;
      //   border-width: 0px 1px 1px 0px !important;
      //   padding: 5px 0px !important;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ActivityDetail.vue